import { render } from "./RichTextPropsCmp.vue?vue&type=template&id=04800530"
import script from "./RichTextPropsCmp.vue?vue&type=script&lang=js"
export * from "./RichTextPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__